import { Catalog } from "@p0security/shared/types/catalog";
import { RecursiveReadonly } from "@p0security/util/types/util";
import { createContext } from "react";

export const CatalogContext = createContext<RecursiveReadonly<Catalog>>({
  risks: {},
  privileges: { aws: {}, azure: {}, gcp: {}, k8s: {}, workspace: {} },
});
